import { render, staticRenderFns } from "./MoleculeDisplayCurrentDate.vue?vue&type=template&id=025fd962&scoped=true&"
import script from "./MoleculeDisplayCurrentDate.vue?vue&type=script&lang=js&"
export * from "./MoleculeDisplayCurrentDate.vue?vue&type=script&lang=js&"
import style0 from "./MoleculeDisplayCurrentDate.vue?vue&type=style&index=0&id=025fd962&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "025fd962",
  null
  
)

export default component.exports